import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

import { CsplTable as Table, Link } from "../../../components";
import { MANAGE_MASTERS_ROUTES } from "../../../utils";
import {
  useRequest,
  useLazyLoadForTable,
  useDeepEffect,
} from "../../../abstracts";
import { setManageInnerDetails } from "../../../contexts";
// import { postCompanyGridView } from "../../services";
import ClearingPartnerCard from "./ClearingPartnerCard";
import { isEmpty } from "lodash";
const GenericTable = ({
  isLoading,
  totalRecords,
  state,
  dispatch,
  clearingPartnerList,
}) => {
  const defaultPageNumbers = {
    from: 1,
    to: 20,
  };

  const [clearingPartnerGridpayload, setClearingPartnerPayload] = useState({
    ...defaultPageNumbers,
  });
  const recordsToDisplay = [
    {
      id: 1,
      clearingPartnerName: "Arise States",
      assosiatedPlans: 20,
    },
    {
      id: 2,
      clearingPartnerName: "BN States",
      assosiatedPlans: 25,
    },
    {
      id: 3,
      clearingPartnerName: "AK Computers",
      assosiatedPlans: 15,
    },
    {
      id: 4,
      clearingPartnerName: "UMA engitech",
      assosiatedPlans: 30,
    },
    {
      id: 5,
      clearingPartnerName: "VAR",
      assosiatedPlans: 10,
    },
    {
      id: 6,
      clearingPartnerName: "JS Morgan Chase",
      assosiatedPlans: 12,
    },
    {
      id: 7,
      clearingPartnerName: "Paribas",
      assosiatedPlans: 10,
    },
  ];

  //   const { response: companiesResponse, loading } = useRequest({
  //     method: postCompanyGridView,
  //     payload: clearingPartnerGridpayload,
  //     defaultResponse: [],
  //   });

  //   const { tableData } = useLazyLoadForTable(companiesResponse, {
  //     searchString: companyGridpayload.searchString,
  //     companyType: companyGridpayload.companyType,
  //     orderDescending: companyGridpayload.orderDescending,
  //   });

  //   useDeepEffect(
  //     () => {
  //       setCompanyGridPayload({
  //         ...companyGridpayload,
  //         ...defaultPageNumbers,
  //         searchString: searchText,
  //         companyType,
  //       });
  //       if (searchText) {
  //         setShowAllRecords(true);
  //       } else {
  //         setShowAllRecords(false);
  //       }
  //     },
  //     [searchText, companyType],
  //     true
  //   );

  //   const scrollEndCallBack = (details) => {
  //     setCompanyGridPayload({
  //       ...companyGridpayload,
  //       from: details.from,
  //       to: details.to,
  //     });
  //   };

  //   const recordsToDisplay = showAllRecords ? tableData : tableData.slice(0, 8);
  const setInnerDetailsFlag = () => {
    // debugger;
    dispatch(setManageInnerDetails(true));
  };
  return (
    <Table isLoading={isLoading} className="clearing-partner-wrapper">
      <Table.Tbody
        // scrollEndCallBack={scrollEndCallBack}
        // totalRecords={totalRecords}
        // interVal={20}
        // isLoading={isLoading || loading}
        className="clearing-partner-card-list-wrapper"
      >
        <Row>
          {!isEmpty(clearingPartnerList) ? (
            clearingPartnerList.map((cp, index) => {
              return (
                <Col md="4" key={index}>
                  <Link
                    to={`${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER_DETAILS}/${cp.id}`}
                    className="clearing-partner-card-item"
                    onClick={() => setInnerDetailsFlag()}
                  >
                    <ClearingPartnerCard {...cp} />
                  </Link>
                </Col>
              );
            })
          ) : (
            <span style={{ margin: "auto", fontSize: "18px" }}>
              No Records Found
            </span>
          )}
        </Row>
      </Table.Tbody>
    </Table>
  );
};

export default GenericTable;
